import TemplateView from '../../../../TemplateView'

export default class Item extends TemplateView {
    constructor({
        text = '',
        onClick = () => {},
        value = null,
    }) {
        super(null)

        this.params = {
            text,
            onClick,
            value,
        }

        this.state = {
            selected: false
        }

        this.onStatePropertyChanged('selected', () => {
            this.$el.toggleClass('selected', this.state.selected)
        })
    }

    templateHtml() {
        return '<div class="listItem"><span class="text"></span></div>'
    }

    afterRender() {
        this.find('.text').text(this.params.text)
        this.$el.on('click', () => {this.params.onClick(this.params.value)})
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/itemsFilter/Item.js